module.exports = __webpack_public_path__ + "assets/linkedin-icon-32.png?dc84b7c3769f7ed8770174a0e0add0e9";